import React, { useEffect, useState } from "react";
import "./index.less";
import { ChatLayoutContainer } from "../ChatLayoutContainer";
import {
    AvatarComProps,
    ContactList,
    ContentTabsTop,
    CustomModal,
    RelationShipTodo,
    RelationshipType,
} from "remo-components";
import { useTranslate } from "@obsbot/remo-i18n";
import { RouteNameType } from "../../route-config";
import { usePushHistory } from "../../utils/routes";
import { Badge } from "antd";
// import { MailOutlined } from "@ant-design/icons";
import { useFriendStore } from "@obsbot/remo-stores";
import { setIntimateRead } from "@obsbot/remo-server-api";
import MsgPNG from "./msg.png";
const RelationshipPage = (): React.ReactElement => {
    const t = useTranslate();
    const pushHistory = usePushHistory();
    const { intimate } = useFriendStore();
    const [currentTab, setCurrentTab] = React.useState<RelationshipType>("lovers");
    const [openInvite, setOpenInvite] = useState<boolean>(false);
    const tabItems = [
        { key: "lovers", label: t("relationship.lovers") },
        { key: "bosom_friend", label: t("relationship.bosom_friend") },
        { key: "buddy", label: t("relationship.buddy") },
    ];

    const handleChangeTab = (key: string): void => {
        setCurrentTab(key as RelationshipType);
    };

    const onClick = (path: string, info?: AvatarComProps): void => {
        if (info) {
            pushHistory(path as RouteNameType, {
                id: info.userID,
                name: info.userName?.toString().trim() || info.userID,
            });
        }
    };

    useEffect(() => {
        // 当接收列表新增时，如果弹窗是打开状态，直接已读
        if (openInvite && intimate.unreadCount > 0) {
            setIntimateRead();
        }
    }, [intimate.unreadCount, openInvite]);

    return (
        <ChatLayoutContainer>
            <div className="relationship-page">
                <ContentTabsTop handleChangeTab={handleChangeTab} tabItems={tabItems} />
                <ContactList
                    modeType="list-relation"
                    relationshipGroup={currentTab}
                    onClick={onClick}
                />
                <div
                    className="affix-container"
                    onClick={() => {
                        setIntimateRead();
                        setOpenInvite(true);
                    }}
                >
                    <Badge count={intimate.unreadCount || 0} offset={[4, -10]} size="small">
                        <img alt="msg" src={MsgPNG} />
                    </Badge>
                </div>
                {openInvite && (
                    <CustomModal
                        destroyOnHidden={true}
                        footer={null}
                        open={openInvite}
                        renderHeader={t("relationship.unhandle-invite")}
                        rootClassName="relationship-drawer"
                        setVisible={setOpenInvite}
                        width={895}
                        onClickClose={() => {
                            setOpenInvite(false);
                        }}
                    >
                        <RelationShipTodo show={openInvite} />
                    </CustomModal>
                )}
            </div>
        </ChatLayoutContainer>
    );
};

export default RelationshipPage;
